export default "__VITE_ASSET__CqCAJgkM__"